import React from 'react';
import EmptyPage from '../../empty-page/emptyPage';

const OrgCampInsights = () => {
    return <EmptyPage />;
};

export default OrgCampInsights;
